import { keyframes } from '@emotion/react';
import { makeStyles } from 'tss-react/mui';

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
`;

export const useCommonClasses = makeStyles()(() => ({
  rotating: {
    animation: `${rotateAnimation} 2s linear infinite`,
  },
}));
